import { RoutesTo } from "@/shared/constants/enums";

export interface DefaultNavbarLink {
  id: number;
  label: DefaultNavbarLinkLabel;
  to: RoutesTo;
  icon: string;
  isDisabled: boolean;
}

export enum DefaultNavbarLinkLabel {
  verification = "Реквизиты",
  wallet = "Кошелек",
  application = "Создание заявки",
  history = "История",
  settings = "Настройки",
}

export enum DefaultNavbarLinkIcon {
  verification = "verification",
  wallet = "wallet",
  application = "application",
  history = "history",
  settings = "settings",
}
